import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import TUIRoomCore from '../../tui-room-core';
import {useChatStore} from '../../../stores/chat';
import {Message} from 'element-ui';
import emoji from './EditorTools/emoji.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatEditor',
  setup(__props) {

const editorInputEle = ref();

const chatStore = useChatStore();
const sendMsg = ref('');
const sendMessage = async () => {
  const msg = sendMsg.value.replace('\n', '');
  sendMsg.value = '';
  if (msg === '') {
    return;
  }
  try {
    const tuiResponse = await TUIRoomCore.sendChatMessage(msg);
    const {code, data: message} = tuiResponse;
    if (code === 0) {
      // 消息发送成功
      chatStore.updateMessageList(message);
    }
  } catch (e) {
    // 消息发送失败
    Message.error('发送消息失败');
  }
};

const handleChooseEmoji = (emojiName: string) => {
  sendMsg.value += emojiName;
  editorInputEle.value.focus();
};


return { __sfc: true,editorInputEle, chatStore, sendMsg, sendMessage, handleChooseEmoji, emoji }
}

})